<!-- crud asignar url de la api URL="url de la api" titulo="un titulo para la pestaña de la pagina" [dato]="variable que contiene el formulario]-->
<app-formulario #ctrl URL="paises" titulo="Pais / Catalogos" [dato]="dato" ></app-formulario>

<!-- Menu principal "-->
<app-sistema-menu></app-sistema-menu>


<div class="contenedor columns " style="height:100%; ">
    <div class="column is-2 is-hidden-mobile menu-izquierda">

        <!-- Menu izquierda del modulo enviroment" -->
        <app-sistema-menu-aside ></app-sistema-menu-aside>
    </div>
    <div class="column" style="padding:0px;">
        <div style="background: #FFF; border-radius: 1em; ">

            <!-- formulario -->
            <form name="form" novalidate [formGroup]="dato" (ngSubmit)="ctrl.enviar()" >
                <section class="hero is-primary">
                    <div class="hero-body">

                        <!-- Opciones  -->
                        <app-formulario-opciones [ctrl]="ctrl" [id]="ctrl.dato.id"></app-formulario-opciones>
                    </div>
                </section>

                <section class="section" style="overflow: auto;padding: 1rem !important;height: 85.8vh;">

                    <div class="field">
                        <label class="label">Nombre:</label>
                        <p class="control has-icons-left has-icons-right">
                            <input class="input" autofocus type="text" [ngClass]="{'is-danger': ctrl.dato.get('nombre').hasError('required') }"
                                placeholder="Nombre" formControlName="nombre">
                            <span class="icon is-small is-right" *ngIf="ctrl.dato.get('nombre').hasError('required') ">
                                <i class="fa fa-warning"></i>
                            </span>
                            <span class="help is-danger" *ngIf="ctrl.dato.get('nombre').hasError('required') ">Este campo es requerido.</span>
                        </p>
                    </div>

                    <div class="columns">
                       <div class="column is-6">
                            <div class="field">
                                <label class="label">Clave ISOA2:</label>
                                <p class="control has-icons-left has-icons-right">
                                    <input class="input" type="text" placeholder="Clave ISOA2" formControlName="clave_ISOA2">
                                </p>
                            </div>
                        </div>

                        <div class="column is-6">
                            <div class="field">
                                <label class="label">Clave A3:</label>
                                <p class="control has-icons-left has-icons-right">
                                    <input class="input" type="text" placeholder="Clave A3" formControlName="clave_A3">
                                </p>
                            </div>
                        </div>
                    </div>

                    <div class="columns">
                       <div class="column is-6">
                            <div class="field">
                                <label class="label">Clave_N3:</label>
                                <p class="control has-icons-left has-icons-right">
                                    <input class="input" type="text" placeholder="Clave N3" formControlName="clave_N3">
                                </p>
                            </div>
                        </div>

                        <div class="column is-6">
                            <div class="field">
                                <label class="label">Prefijo Teléfono:</label>
                                <p class="control has-icons-left has-icons-right">
                                    <input class="input" type="text" placeholder="Prefijo Teléfono" formControlName="prefijo_telefono">
                                </p>
                            </div>
                        </div>
                    </div>

                </section>
            </form>
        </div>
    </div>
</div>
